export const Types = {
  SEARCH_DADOS: "dadosCadastrais/SEARCH_DADOS",
  SEARCH_DADOS_TAB: "dadosCadastrais/SEARCH_DADOS_TAB",
  SEARCH_DADOS_CNPJ_TAB: "dadosCadastrais/SEARCH_DADOS_CNPJ_TAB",
  SEARCH_DADOS_RELACIONADAS_TAB:
    "dadosCadastrais/SEARCH_DADOS_RELACIONADAS_TAB",
  SEARCH_DADOS_SUCCESS: "dadosCadastrais/SEARCH_DADOS_SUCCESS",
  SEARCH_DADOS_TAB_SUCCESS: "dadosCadastrais/SEARCH_DADOS_TAB_SUCCESS",
  SEARCH_DADOS_CNPJ_TAB_SUCCESS:
    "dadosCadastrais/SEARCH_DADOS_CNPJ_TAB_SUCCESS",
  SEARCH_DADOS_RELACIONADAS_TAB_SUCCESS:
    "dadosCadastrais/SEARCH_DADOS_RELACIONADAS_TAB_SUCCESS",
  UNSET_REDIRECT: "dadosCadastrais/UNSET_REDIRECT"
};

const INITIAL_STATE = {
  target: null,
  dado: "",
  dadoTab: "",
  dataDados: null,
  dataDadosArray: [],
  dataDadosArrayCnpj: [],
  dataDadosArrayRelacionadas: [],
  redirect: false,
  redirectCnpj: false,
  redirectRelacionadas: false
};

export default function dadosCadastrais(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.SEARCH_DADOS:
      return {
        ...state,
        target: action.payload.target,
        dado: action.payload.dado
      };
    case Types.SEARCH_DADOS_TAB:
      return {
        ...state,
        dadoTab: action.payload.dado
      };
    case Types.SEARCH_DADOS_CNPJ_TAB:
      return {
        ...state,
        dadoTab: action.payload.dado
      };
    case Types.SEARCH_DADOS_RELACIONADAS_TAB:
      return {
        ...state,
        dadoTab: action.payload.dado
      };
    case Types.SEARCH_DADOS_SUCCESS:
      return {
        ...state,
        dataDados: action.payload.data
      };
    case Types.SEARCH_DADOS_TAB_SUCCESS:
      return {
        ...state,
        dataDadosArray: action.payload.dataArray,
        redirect: true
      };
    case Types.SEARCH_DADOS_RELACIONADAS_TAB_SUCCESS:
      return {
        ...state,
        dataDadosArrayRelacionadas: action.payload.dataArray,
        redirectRelacionadas: true
      };
    case Types.SEARCH_DADOS_CNPJ_TAB_SUCCESS:
      return {
        ...state,
        dataDadosArrayCnpj: action.payload.dataArray,
        redirectCnpj: true
      };
    case Types.UNSET_REDIRECT:
      return {
        ...state,
        redirect: false,
        redirectCnpj: false,
        redirectRelacionadas: false
      };
    default:
      return state;
  }
}

export const Creators = {
  searchDados: (target, dado) => ({
    type: Types.SEARCH_DADOS,
    payload: { target, dado }
  }),
  searchDadosTab: (target, dado) => ({
    type: Types.SEARCH_DADOS_TAB,
    payload: { target, dado }
  }),
  searchDadosCnpjTab: (target, dado) => ({
    type: Types.SEARCH_DADOS_CNPJ_TAB,
    payload: { target, dado }
  }),
  searchDadosRelacionadasTab: (target, dado) => ({
    type: Types.SEARCH_DADOS_RELACIONADAS_TAB,
    payload: { target, dado }
  }),
  searchDadosSuccess: data => ({
    type: Types.SEARCH_DADOS_SUCCESS,
    payload: { data }
  }),
  searchDadosTabSuccess: dataArray => ({
    type: Types.SEARCH_DADOS_TAB_SUCCESS,
    payload: { dataArray }
  }),
  searchDadosCnpjTabSuccess: dataArray => ({
    type: Types.SEARCH_DADOS_CNPJ_TAB_SUCCESS,
    payload: { dataArray }
  }),
  searchDadosRelacionadasTabSuccess: dataArray => ({
    type: Types.SEARCH_DADOS_RELACIONADAS_TAB_SUCCESS,
    payload: { dataArray }
  }),
  unsetRedirect: () => ({
    type: Types.UNSET_REDIRECT
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/dadosCadastrais.js